export interface Article {
  id: number;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  author: string;
  publishDate: string;
  image: string;
  tags: string[];
  readCount: number;
}

export const articles: Article[] = [
  {
    id: 1,
    title: '2024年最值得期待的10部日本电影',
    excerpt: '从是枝裕和到新海诚，盘点今年最受瞩目的日本电影新作，每一部都不容错过。',
    content: `<p>2024年对于日本电影爱好者来说，注定是一个丰收之年。多位重量级导演携新作回归，类型涵盖文艺、动画、商业大片，满足不同观众的观影需求。</p>
    <h2>1. 是枝裕和最新力作</h2>
    <p>继《怪物》在戛纳电影节大获成功之后，是枝裕和导演的新项目已经启动。据悉，新片将继续关注家庭与社会议题，延续导演一贯的人文关怀风格。</p>
    <h2>2. 新海诚新作预定</h2>
    <p>继《铃芽之旅》全球票房突破3亿美元后，新海诚导演的下一部作品备受关注。虽然具体内容尚未公布，但粉丝们已经充满期待。</p>
    <h2>3. 漫画改编热潮持续</h2>
    <p>日本漫画改编电影在2024年依然热度不减。多部人气漫画的真人版电影即将上映，包括知名IP的最新剧场版。这些作品凭借原作庞大的粉丝基础，已经引发了广泛讨论。</p>
    <h2>4. 动画电影新势力</h2>
    <p>除了传统动画巨头，越来越多的新兴动画工作室也在崭露头角。2024年将有多部原创动画电影上映，为日本动画电影注入新鲜血液。</p>
    <h2>5. 国际合拍片增加</h2>
    <p>日本电影与国际制作团队的合拍趋势越来越明显。2024年将有多部日本与欧美、亚洲其他国家合拍的电影上映，这些作品在保持日本电影特色的同时，也融入了更多国际元素。</p>
    <p>总的来说，2024年的日本电影市场值得期待。无论你是喜欢文艺片、商业片还是动画电影，都能找到心仪的作品。让我们拭目以待！</p>`,
    category: 'movie',
    categoryName: '电影',
    author: '影视编辑·小林',
    publishDate: '2024-03-15',
    image: 'https://sakuraon.github.io/api/search-image?query=Japanese%20cinema%20marquee%20with%20film%20posters%2C%20vintage%20movie%20theater%20entrance%2C%20warm%20evening%20lighting%2C%20nostalgic%20atmosphere%2C%20cinematic%20photography&width=1200&height=630&seq=article-2024-movies&orientation=landscape',
    tags: ['日本电影', '2024新片', '电影推荐'],
    readCount: 12850,
  },
  {
    id: 2,
    title: '日剧推荐：这些高分日剧你绝对不能错过',
    excerpt: '从温馨治愈到烧脑悬疑，为你精心挑选近两年口碑爆棚的高分日剧，追剧清单请收好。',
    content: `<p>近年来，日本电视剧市场涌现了大量优秀作品，无论是原创剧本还是漫画改编，都在品质上有了显著提升。以下是我们精心挑选的几部高分日剧，每一部都值得你投入时间观看。</p>
    <h2>《重启人生》- 豆瓣9.4分</h2>
    <p>这部由笨蛋节奏编剧的作品，讲述了一个普通上班族意外获得重生机会的故事。与常见的重生题材不同，本作没有宏大的使命或复仇情节，而是以一种轻松幽默的方式探讨人生的意义和选择。主演安藤樱的表演自然流畅，让人感同身受。</p>
    <h2>《VIVANT》- 豆瓣9.0分</h2>
    <p>堺雅人时隔多年回归主演的这部大型谍战剧，制作规模堪比电影。故事跨越日本、蒙古等多个国家，融合了谍战、悬疑、动作等多种元素。阿部宽、役所广司等实力派演员的加盟，更让这部剧看点十足。</p>
    <h2>《Silent》- 豆瓣8.9分</h2>
    <p>这部纯爱剧讲述了一个因疾病失去听力的男孩与初恋女友重逢的故事。川口春奈和目黑莲的表演真挚动人，剧中关于沟通、理解和爱的探讨引发了广泛共鸣。准备好纸巾，这部剧真的很好哭。</p>
    <p>以上就是我们推荐的高分日剧。无论你喜欢什么类型，相信这份清单中总有一部适合你。祝追剧愉快！</p>`,
    category: 'drama',
    categoryName: '日剧',
    author: '影视编辑·美雪',
    publishDate: '2024-03-12',
    image: 'https://sakuraon.github.io/api/search-image?query=Japanese%20living%20room%20with%20large%20TV%20displaying%20drama%20scene%2C%20cozy%20evening%20atmosphere%2C%20warm%20lighting%2C%20minimal%20interior%2C%20comfortable&width=1200&height=630&seq=article-drama-recs&orientation=landscape',
    tags: ['日剧推荐', '高分日剧', '追剧清单'],
    readCount: 23560,
  },
  {
    id: 3,
    title: '日本动漫新番指南：2024春季档必追番剧',
    excerpt: '春季新番陆续开播，哪些作品值得追？这份详细的新番指南帮你筛选必追佳作。',
    content: `<p>2024年春季档日本动漫新番已经陆续开播，本季共有超过50部新作和续作登场。面对如此丰富的选择，很多观众可能会感到选择困难。别担心，我们为你整理了春季档最值得关注的几部作品。</p>
    <h2>续作篇：热门IP回归</h2>
    <p>本季有多部人气动画的续作回归。《鬼灭之刃 柱训练篇》作为连接前作和最终决战的重要篇章，备受期待。《关于我转生变成史莱姆这档事》第三季也将在本季播出，利姆鲁的建国之旅继续展开。</p>
    <h2>新作篇：原创与改编</h2>
    <p>在原创动画方面，多部备受关注的新作将首次亮相。漫画改编方面，《怪兽8号》的动画化是春季档最受瞩目的作品之一。这部在Jump+上人气爆棚的漫画，凭借其独特的世界观和精彩的动作场面，被粉丝称为"下一个爆款"。</p>
    <h2>小众佳作推荐</h2>
    <p>除了热门作品，本季还有一些相对小众但品质上乘的作品值得关注。比如《迷宫饭》继续用美食与冒险的独特结合俘获观众。《防风少年》则用热血青春故事打动人心。</p>
    <p>希望这份春季新番指南能帮你找到心仪的动漫作品。记得每周关注更新，和我们一起追番吧！</p>`,
    category: 'anime',
    categoryName: '动漫',
    author: '影视编辑·太一',
    publishDate: '2024-04-01',
    image: 'https://sakuraon.github.io/api/search-image?query=Anime%20style%20spring%20scene%20with%20cherry%20blossoms%2C%20anime%20characters%20gathered%2C%20vibrant%20colors%2C%20festive%20atmosphere%2C%20new%20season%20celebration&width=1200&height=630&seq=article-anime-spring&orientation=landscape',
    tags: ['动漫新番', '春季档', '追番指南'],
    readCount: 18920,
  },
  {
    id: 4,
    title: '日本综艺为什么这么好笑？揭秘幕后制作',
    excerpt: '深入日本综艺节目制作现场，了解那些让你捧腹大笑的企划是如何诞生的。',
    content: `<p>日本综艺节目以其独特的创意、夸张的反应和精心设计的企划闻名于世。无论是搞笑艺人的精湛表演，还是节目中那些让人意想不到的环节，都让观众欲罢不能。那么，日本综艺为什么这么好笑？让我们深入幕后一探究竟。</p>
    <h2>企划创意的来源</h2>
    <p>日本综艺的企划会议是一个极其重视创意的过程。制作团队会定期举行"企划会议"，每位成员都可以提出自己的想法。有趣的是，很多经典企划往往来自于制作人的日常生活观察。比如《月曜夜未央》中那些关注"素人"的企划，就源于制作人对普通日本人生活的长期观察。</p>
    <h2>搞笑艺人的专业素养</h2>
    <p>日本搞笑艺人的培养体系非常完善。从专门的培训学校到剧场的实战锻炼，搞笑艺人需要经过多年的磨练才能登上电视荧幕。他们不仅要有即兴反应能力，还需要掌握"话术"、"吐槽"、"装傻"等专业技能。</p>
    <h2>后期制作的魔法</h2>
    <p>日本综艺的后期制作同样功不可没。精心设计的字幕特效、恰到好处的背景音乐、巧妙的剪辑节奏，都为节目的笑果增色不少。特别是那些标志性的"大头特效"和"变声处理"，已经成为日本综艺的代名词。</p>
    <p>日本综艺的成功离不开每一个环节的精心打磨。正是因为制作团队对品质的极致追求，才让我们能够享受到如此高质量的娱乐内容。</p>`,
    category: 'variety',
    categoryName: '综艺',
    author: '影视编辑·翔太',
    publishDate: '2024-03-20',
    image: 'https://sakuraon.github.io/api/search-image?query=Japanese%20TV%20studio%20behind%20the%20scenes%2C%20production%20crew%20working%2C%20cameras%20and%20lights%2C%20professional%20broadcast%20setting%2C%20busy%20atmosphere&width=1200&height=630&seq=article-variety-bts&orientation=landscape',
    tags: ['日本综艺', '幕后制作', '搞笑艺人'],
    readCount: 9870,
  },
  {
    id: 5,
    title: '日本动画电影全球票房TOP10盘点',
    excerpt: '从《千与千寻》到《铃芽之旅》，日本动画电影在全球市场屡创佳绩，盘点史上最卖座的十部作品。',
    content: `<p>日本动画电影在全球范围内拥有庞大的粉丝群体，近年来更是屡屡创造票房奇迹。从宫崎骏的经典之作到新海诚的现象级作品，日本动画电影正在以前所未有的速度征服全球观众。以下是日本动画电影全球票房TOP10的完整盘点。</p>
    <h2>第一名：《千与千寻》</h2>
    <p>宫崎骏的这部不朽经典以约3.95亿美元的全球票房高居榜首。作为唯一一部获得奥斯卡最佳动画长片奖的非英语动画电影，《千与千寻》以其丰富的想象力和深刻的主题征服了全世界的观众。</p>
    <h2>第二名：《你的名字。》</h2>
    <p>新海诚导演的这部作品在全球收获了约3.8亿美元票房，曾一度打破了《千与千寻》保持了多年的纪录。影片中唯美的画面和动人的爱情故事引发了全球范围内的讨论热潮。</p>
    <h2>第三名：《铃芽之旅》</h2>
    <p>新海诚的最新作品《铃芽之旅》以约3.23亿美元的全球票房位居第三。影片在日本本土和海外的表现都十分出色，再次证明了新海诚在全球动画电影市场的影响力。</p>
    <p>从榜单可以看出，日本动画电影正在经历一个前所未有的黄金时期。以新海诚为代表的新生代导演正在接过宫崎骏的接力棒，将日本动画电影推向新的高度。</p>`,
    category: 'anime',
    categoryName: '动漫',
    author: '影视编辑·花子',
    publishDate: '2024-02-28',
    image: 'https://sakuraon.github.io/api/search-image?query=Anime%20film%20collage%20with%20famous%20movie%20scenes%2C%20Spirited%20Away%20and%20Your%20Name%20style%2C%20cinematic%20lighting%2C%20artistic%20composition%2C%20warm%20golden%20tones&width=1200&height=630&seq=article-anime-boxoffice&orientation=landscape',
    tags: ['动画电影', '票房排行', '宫崎骏'],
    readCount: 15670,
  },
  {
    id: 6,
    title: '日本晨间剧的魅力：为什么日本人离不开晨间剧',
    excerpt: '每天早上15分钟的晨间剧，为何能成为日本人日常生活中不可或缺的一部分？',
    content: `<p>在日本，有一种独特的电视剧类型叫做"晨间剧"（朝ドラ）。每天早上8点播出，每集只有15分钟，却拥有着惊人的收视率和文化影响力。这种看似简单的节目形式，为何能深深扎根于日本人的日常生活？</p>
    <h2>晨间剧的历史与传承</h2>
    <p>NHK的晨间剧系列始于1961年，至今已有超过60年的历史。最初是为了给家庭主妇提供早晨的娱乐内容，如今已经发展成为日本电视剧文化的重要组成部分。许多如今活跃在日本影视圈的知名演员，都曾通过晨间剧出道或走红。</p>
    <h2>晨间剧的主题特色</h2>
    <p>晨间剧通常以女性为主角，讲述她们克服困难、实现梦想的励志故事。这种积极向上、充满希望的主题，正好契合了早晨这个时间段的氛围——给观众一整天满满的正能量。</p>
    <h2>晨间剧的文化影响</h2>
    <p>晨间剧不仅影响了日本人的收视习惯，还对日本社会产生了深远影响。剧中的取景地常常成为旅游热点，主角使用的物品会引发购买热潮。一部成功的晨间剧能够带动当地经济发展，这种现象被称为"晨间剧效应"。</p>
    <p>正是这种独特的魅力，让晨间剧成为日本电视文化中不可替代的存在。每天早上15分钟，是无数日本人开启一天的精神食粮。</p>`,
    category: 'drama',
    categoryName: '日剧',
    author: '影视编辑·优子',
    publishDate: '2024-03-05',
    image: 'https://sakuraon.github.io/api/search-image?query=Japanese%20morning%20living%20room%20with%20TV%20playing%2C%20sunlight%20through%20window%2C%20breakfast%20table%2C%20cozy%20morning%20atmosphere%2C%20warm%20lighting&width=1200&height=630&seq=article-morning-drama&orientation=landscape',
    tags: ['晨间剧', '日剧文化', 'NHK'],
    readCount: 11230,
  },
];

export function getArticleById(id: number): Article | undefined {
  return articles.find((a) => a.id === id);
}

export function getArticlesByCategory(category: string): Article[] {
  return articles.filter((a) => a.category === category);
}

export function getRelatedArticles(article: Article, count: number = 3): Article[] {
  return articles
    .filter((a) => a.id !== article.id && a.category === article.category)
    .slice(0, count);
}